import { axios } from '@/utils/axios'
import { find, groupBy, sortBy, toArray } from 'lodash'
import scheduleStatusMap from '@/assets/js/service'
import { flightCities } from '@/assets/js/data'

// 查询航班动态
export async function schedule (params) {
  const result = await axios({
    url: '/api/Passenger/flightDynamicsV2',
    method: 'post',
    data: params
  })

  const {
    list
  } = result
  if (list && list.length) {
    const airport = await flightCities()
    list.forEach(item => {
      const departure = find(airport, {
        code: item.depStn
      })
      const arrival = find(airport, {
        code: item.arrStn
      })

      if (departure) {
        item.depStn = departure.city
      }

      if (arrival) {
        item.arrStn = arrival.city
      }

      // 国际航线
      if (item.fltType === 'I') {
        item.ataChn = item.ataLocal
        item.atdChn = item.atdLocal
        item.etaChn = item.etaLocal
        item.etdChn = item.etdLocal
        item.staChn = item.staLocal
        item.stdChn = item.stdLocal
        item.tDwnChn = item.tDwnLocal
        item.tOffChn = item.tOffLocal
      }

      item.status = scheduleStatusMap[item.status] || item.status
    })

    // 经停数据处理
    result.list = handleStopCities(list)
  }
  return result
}

// 退票进度查询
export async function refundSearch (params) {
  const result = await axios({
    url: '/api/Passenger/ticketRefundProcess',
    method: 'post',
    data: params
  })

  const airport = await flightCities()
  if (result.success) {
    const { ticket } = result.data || {}

    if (ticket && ticket.segment) {
      ticket.segment.forEach(item => {
        item.orgCityName = getAirportName(airport, item.orgCity)
        item.arrCityName = getAirportName(airport, item.arrCity)
      })
    }
  }
  return result
}

function getAirportName (airport, code) {
  const target = find(airport, { code: code })
  if (target) {
    return target.city ? target.city : '--'
  } else {
    return code
  }
}

function handleStopCities (list = []) {
  const listObj = groupBy(list, function (item) { return item.flightNo })
  const backList = toArray(listObj)
  if (backList && backList.length > 0) {
    for (let i = 0; i < backList.length; i++) {
      // 航段内排序（如果有两个及以上航段，需要排序） etdChn预计起飞的时间戳排序
      const sortArr = sortBy(backList[i], function (item) { return item.etdChn })
      backList[i] = sortArr
    }
  }
  // 转成新的一维数组
  const newArr = []
  for (let i = 0; i < backList.length; i++) {
    const len = backList[i].length
    if (len > 1) {
      for (let j = 0; j < len; j++) {
        const obj = backList[i][j]
        // 排除备降的数据
        if (j < len - 1 && obj.divRecode !== 'Y') {
          obj.isStop = true
        }
        newArr.push(obj)
      }
    } else {
      newArr.push(backList[i][0])
    }
  }
  return newArr
}
